import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white border-b border-gray-300" }
const _hoisted_2 = { class: "flex justify-between w-full p-6 mx-auto max-w-screen-xl" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "ml-6" }
const _hoisted_5 = {
  class: "text-lg font-bold text-gray-900",
  "data-cy": "nav-patient-name"
}
const _hoisted_6 = { class: "uppercase" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "text-base font-semibold uppercase text-gray-400",
  "data-cy": "nav-patient-id"
}
const _hoisted_9 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_10 = { class: "grid gap-x-8 grid-rows-2 grid-flow-col" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "text-gray-500 mr-3" }
const _hoisted_13 = {
  class: "font-medium",
  "data-cy": "nav-patient-dob"
}
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "text-gray-500 mr-3" }
const _hoisted_16 = {
  class: "font-medium",
  "data-cy": "nav-patient-age"
}
const _hoisted_17 = { class: "flex justify-between" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-gray-500 mr-3" }
const _hoisted_20 = {
  class: "font-medium",
  "data-cy": "nav-patient-sex"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "text-gray-500 mr-3" }
const _hoisted_23 = {
  class: "font-medium",
  "data-cy": "nav-patient-sex"
}
const _hoisted_24 = { class: "flex justify-between" }
const _hoisted_25 = { class: "text-gray-500 mr-3" }
const _hoisted_26 = {
  class: "font-medium",
  "data-cy": "nav-patient-ethnicity"
}
const _hoisted_27 = { class: "flex justify-between" }
const _hoisted_28 = { class: "text-gray-500 mr-3" }
const _hoisted_29 = {
  class: "font-medium",
  "data-cy": "nav-patient-phone"
}
const _hoisted_30 = {
  key: 0,
  class: "flex justify-between items-center"
}
const _hoisted_31 = {
  class: "font-medium uppercase",
  "data-cy": "nav-patient-mrn"
}
const _hoisted_32 = {
  key: 0,
  class: "border-t"
}
const _hoisted_33 = { class: "flex w-full h-16 mx-auto max-w-screen-xl" }
const _hoisted_34 = { class: "flex flex-grow" }
const _hoisted_35 = { class: "font-semibold text-gray-400" }
const _hoisted_36 = { class: "font-semibold text-gray-400" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-400" }, "Dev Lab", -1)

import { computed, PropType, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { getDobFromISOString, getNhsNumberFromPatient } from '@/helpers/patient.helper';
import { Organisation, Patient } from '@/models';
import BaseIcon from '@/lib/components/Icon/BaseIcon.vue';
import ButtonLink from '@/lib/components/Button/ButtonLink.vue';
import NavDropdownButton from '@/lib/components/Navigation/NavDropdownButton.vue';
import NavLink from '@/lib/components/Navigation/NavLink.vue';
import BaseBanner from '@/lib/components/Banner/BaseBanner.vue';
import { FEATURES, sexOptions, genderOptions } from '@/constants';
import { BasePopover, PopoverLink } from '@/lib/components/Popover';
import { usePatientStore } from '@/stores/patient.store';
import { isFeatureFlagEnabled } from '@/helpers/feature-flag.helper';
import { PatientEpisodeService } from '@/services/api/patient-episode.service';
import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios';
import { useNotificationStore } from '@/stores/notification.store';
import { IBD, HomeMonitoringPathways } from '@/lib/components/Programs/IbdProgram/constants';
import { useRoute } from 'vue-router';
import { usePathwayName } from '@/composables/pathways';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleNavigation',
  props: {
  patient: {
    type: Object as PropType<Patient>,
    required: true
  },
  organisation: {
    type: Object as PropType<Organisation>,
    required: true
  },
  hideTabs: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;

const { t, d } = useI18n();


const route = useRoute();
const patientStore = usePatientStore();
const notificationStore = useNotificationStore();
const virtualDoctorFeatureFlag = FEATURES.VIRTUAL_DOCTOR;
const clinicalBlocksFeatureFlag = FEATURES.CLINICAL_BLOCKS;
const patientRecordPathwaysFeatureFlag = FEATURES.PATIENT_RECORD_PATHWAYS;
const isIbdFeatureEnabled = isFeatureFlagEnabled(FEATURES.IBD_PATHWAYS);
const episodeOfCareId = ref(route.params.episodeOfCareId ?? '');
const worklistId = ref('');
const request = ref<CancelTokenSource | null>(null);
const copdLatestProgramsAcrossAllPathways = computed<Patient['copd_home_monitoring_latest_programs_across_all_pathways']>(
  () => props.patient?.copd_home_monitoring_latest_programs_across_all_pathways
);
const medicationsAndAllergiesMenuItems = [
  {
    type: 'link',
    routeName: 'blocks-medications-statement',
    i18nKey: 'projects.clinical-blocks.medications-statement'
  },
  {
    type: 'divider'
  },
  {
    type: 'link',
    routeName: 'blocks-allergies',
    i18nKey: 'projects.clinical-blocks.allergies'
  }
];
const familyAndSocialHistoryMenuItems = [
  {
    type: 'link',
    routeName: 'blocks-family-history',
    i18nKey: 'projects.clinical-blocks.family-history'
  },
  {
    type: 'divider'
  },
  {
    type: 'link',
    routeName: 'blocks-tobacco-smoking-summary',
    i18nKey: 'projects.clinical-blocks.tobacco-smoking-summary'
  },
  {
    type: 'link',
    routeName: 'blocks-alcohol-consumption-summary',
    i18nKey: 'projects.clinical-blocks.alcohol-consumption-summary'
  }
];
const devLabMenuItems = [
  {
    type: 'link',
    routeName: 'blocks-management-plan',
    i18nKey: 'projects.clinical-blocks.management-plan'
  },
  {
    type: 'divider'
  },
  {
    type: 'link',
    routeName: 'blocks-presenting-complaint',
    i18nKey: 'projects.clinical-blocks.presenting-complaint'
  }
];

const sex = computed(() => sexOptions().find((option) => option.value === props.patient.sex));
const copdHomeMonitoringProgramId = computed<string|null>(() => props.patient.copd_home_monitoring_program?.id || null);
const gender = computed(() => genderOptions().find((option) => option.value === props.patient.gender));
const useGender = computed(() => props.organisation?.uses_gender && props.patient.gender);
const showNhsNumber = computed(() => patientStore.showNhsNumber);
const nhsNumberFormatted = computed<string>(() => {
  const nhsNumber = getNhsNumberFromPatient(props.patient);
  return nhsNumber || (t('platform.common.none') as string);
});
const isCopdAdmissionAvoidanceFeatureEnabled = computed<boolean>(
  () => isFeatureFlagEnabled(FEATURES.COPD_ADMISSION_AVOIDANCE)
);
const isOnVirtualWardPage = computed<boolean>(() => route.name === PATIENT_VIRTUAL_WARD_ROUTE);

onBeforeMount(async () => {
  if (isIbdFeatureEnabled && (!episodeOfCareId.value || !worklistId.value)) {
    await fetchPatientEpisodes();
  }
});

onBeforeUnmount(() => {
  if (request.value) {
    request.value.cancel();
  }
});

const patientEpisodeService = new PatientEpisodeService(props.organisation.id, props.patient.id);
const fetchPatientEpisodes = async () => {
  request.value = axios.CancelToken.source();
  const requestConfig: AxiosRequestConfig = {
    params: { 'filter[active]': true },
    cancelToken: request.value.token
  };
  try {
    const patientEpisodes = (await patientEpisodeService.index(requestConfig)).data;
    const episodes = patientEpisodes.find(({ worklist }) => worklist?.name.split(' ')[0] === IBD);
    worklistId.value = episodes?.worklist?.id ?? '';
    episodeOfCareId.value = episodes?.id ?? '';
  } catch (e) {
    if (!axios.isCancel(e)) {
      notificationStore.addErrorNotification({ title: t('platform.error.fetch-data') });
    }
  } finally {
    request.value = null;
  }
};

const formatDate = (date: string | null, type = 'short'): string => date ? d(getDobFromISOString(date), type) : '';

const PATIENT_VIRTUAL_WARD_ROUTE = 'patient-virtual-ward';


return (_ctx: any,_cache: any) => {
  const _component_MkBadge = _resolveComponent("MkBadge")!
  const _directive_feature_flagged = _resolveDirective("feature-flagged")!
  const _directive_allow = _resolveDirective("allow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ButtonLink, {
          to: { name: 'patient-list', params: { organisationId: __props.organisation.id } },
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseIcon, {
              name: "arrow-left",
              class: "text-lg text-white stroke-1.5"
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.patient.last_name), 1),
            _createTextVNode(", " + _toDisplayString(__props.patient.first_name) + " ", 1),
            (__props.patient.deceased_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('custom.uhb.patient.deceased-title')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, "ID: " + _toDisplayString(__props.patient.mrn), 1),
            (__props.patient.minor_patients && __props.patient.minor_patients.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createVNode(_component_MkBadge, {
                    color: "primary",
                    size: "xsmall",
                    class: "capitalize"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.patient.major-indicator')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('platform.patient.dob')), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(__props.patient.date_of_birth)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('platform.patient.age')), 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('platform.patient.years', {age: __props.patient.age})), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_unref(useGender))
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('platform.patient.gender')), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(gender) && _unref(gender).label), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('platform.patient.sex')), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(sex) && _unref(sex).label), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('platform.patient.ethnicity')), 1),
          _createElementVNode("span", _hoisted_26, _toDisplayString(__props.patient.ethnicity ? __props.patient.ethnicity.title : _ctx.$t('platform.patient.not-specified')), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('platform.patient.phone')), 1),
          _createElementVNode("span", _hoisted_29, _toDisplayString(__props.patient.contact_number), 1)
        ]),
        (_unref(showNhsNumber))
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(BaseIcon, { name: "nhs-logo" }),
              _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(nhsNumberFormatted)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!__props.hideTabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(NavLink, {
                "data-cy": "nav-patient-details-nav",
                to: {
              name: 'patient-details',
              params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('platform.common.details')), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _withDirectives((_openBlock(), _createBlock(NavLink, {
                to: {
              name: 'pathway-episodes',
              params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('projects.patient-record.pathway-episodes')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_feature_flagged, _unref(patientRecordPathwaysFeatureFlag)]
              ]),
              (_unref(copdHomeMonitoringProgramId) && !_unref(isCopdAdmissionAvoidanceFeatureEnabled))
                ? _withDirectives((_openBlock(), _createBlock(NavLink, {
                    key: 0,
                    to: {
              name: PATIENT_VIRTUAL_WARD_ROUTE,
              params: {
                patientId: _unref(route).params.patientId,
                programId: _unref(copdHomeMonitoringProgramId),
                organisationId: __props.organisation.id,
                pathway: _unref(HomeMonitoringPathways).CopdEarlySupportedDischarge
              }
            }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.copd.virtual-ward')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])), [
                    [_directive_allow, 'copd-home-monitoring:program:read']
                  ])
                : _createCommentVNode("", true),
              (_unref(isCopdAdmissionAvoidanceFeatureEnabled) && _unref(copdLatestProgramsAcrossAllPathways)?.length)
                ? (_openBlock(), _createBlock(_unref(BasePopover), {
                    key: 1,
                    "data-dusk": "virtual-ward-drop-down"
                  }, {
                    button: _withCtx(() => [
                      _createVNode(NavDropdownButton, {
                        class: "mx-5",
                        "is-active": _unref(isOnVirtualWardPage),
                        "icon-colour": !_unref(isOnVirtualWardPage) ? 'text-gray-400': ''
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass([{ 'text-gray-400' : !_unref(isOnVirtualWardPage) }, "font-semibold"])
                          }, _toDisplayString(_ctx.$t('custom.uhb.copd.virtual-ward')), 3)
                        ]),
                        _: 1
                      }, 8, ["is-active", "icon-colour"])
                    ]),
                    menu: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(copdLatestProgramsAcrossAllPathways), ({ id, worklist }) => {
                        return (_openBlock(), _createBlock(_unref(PopoverLink), {
                          key: id,
                          active: worklist.slug === _unref(route).params?.pathway,
                          to: {
                    name: PATIENT_VIRTUAL_WARD_ROUTE,
                    params: {
                      patientId: _unref(route).params.patientId,
                      organisationId: __props.organisation.id,
                      programId: id,
                      pathway: worklist.slug
                    }
                  }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(usePathwayName)(worklist.slug)), 1)
                          ]),
                          _: 2
                        }, 1032, ["active", "to"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (episodeOfCareId.value && worklistId.value)
                ? _withDirectives((_openBlock(), _createBlock(NavLink, {
                    key: 2,
                    to: {
              name: 'patient-episode-of-care',
              params: {
                patientId: _unref(route).params.patientId,
                organisationId: __props.organisation.id,
                episodeOfCareId: episodeOfCareId.value,
                worklistId: worklistId.value
              }
            }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.ibd.ibd')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])), [
                    [_directive_allow, 'patient:read']
                  ])
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createBlock(NavLink, {
                "data-cy": "consults-nav",
                to: {
              name: 'patient-consults',
              params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.consult.consults')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_allow, 'consult:read']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(BasePopover), { "data-cy": "medications-and-allergies-nav" }, {
                button: _withCtx(() => [
                  _createVNode(NavDropdownButton, { class: "mx-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('projects.patient-record.medications-and-allergies')), 1)
                    ]),
                    _: 1
                  })
                ]),
                menu: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(medicationsAndAllergiesMenuItems, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (item.type === 'link')
                        ? (_openBlock(), _createBlock(_unref(PopoverLink), {
                            key: index,
                            to: {
                    name: item.routeName,
                    params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(item.i18nKey)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (item.type === 'divider')
                        ? (_openBlock(), _createElementBlock("hr", {
                            key: index,
                            class: "border-gray-200"
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 64))
                ]),
                _: 1
              })), [
                [_directive_feature_flagged, _unref(clinicalBlocksFeatureFlag)]
              ]),
              _withDirectives((_openBlock(), _createBlock(NavLink, {
                "data-cy": "problem-diagnosis-nav",
                to: {
              name: 'blocks-problem-diagnosis-list',
              params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('projects.clinical-blocks.problem-diagnosis-list')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_feature_flagged, _unref(clinicalBlocksFeatureFlag)]
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(BasePopover), { "data-cy": "family-and-social-history-nav" }, {
                button: _withCtx(() => [
                  _createVNode(NavDropdownButton, { class: "mx-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('projects.patient-record.family-and-social-history')), 1)
                    ]),
                    _: 1
                  })
                ]),
                menu: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(familyAndSocialHistoryMenuItems, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (item.type === 'link')
                        ? (_openBlock(), _createBlock(_unref(PopoverLink), {
                            key: index,
                            to: {
                    name: item.routeName,
                    params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(item.i18nKey)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (item.type === 'divider')
                        ? (_openBlock(), _createElementBlock("hr", {
                            key: index,
                            class: "border-gray-200"
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 64))
                ]),
                _: 1
              })), [
                [_directive_feature_flagged, _unref(clinicalBlocksFeatureFlag)]
              ]),
              _withDirectives((_openBlock(), _createBlock(NavLink, {
                to: {
              name: 'patient-scans',
              params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('platform.patient.imaging')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_allow, 'patent-scans:read']
              ]),
              _withDirectives((_openBlock(), _createBlock(NavLink, {
                "data-cy": "prescriptions-nav",
                to: {
              name: 'patient-prescriptions',
              params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('custom.menicon.prescriptions.prescriptions')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_allow, 'menicon-prescription:read']
              ]),
              _withDirectives((_openBlock(), _createBlock(NavLink, {
                "data-cy": "virtual-doctor-nav",
                to: {
              name: 'virtual-doctor',
              params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('custom.menicon.virtual-doctor.title')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_feature_flagged, _unref(virtualDoctorFeatureFlag)],
                [_directive_allow, 'menicon-virtual-doctor:read']
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _withDirectives((_openBlock(), _createBlock(_unref(BasePopover), { "data-cy": "clinical-blocks-nav" }, {
                button: _withCtx(() => [
                  _createVNode(NavDropdownButton, null, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  })
                ]),
                menu: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(devLabMenuItems, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (item.type === 'link')
                        ? (_openBlock(), _createBlock(_unref(PopoverLink), {
                            key: index,
                            to: {
                    name: item.routeName,
                    params: { patientId: _unref(route).params.patientId, organisationId: __props.organisation.id }
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(item.i18nKey)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (item.type === 'divider')
                        ? (_openBlock(), _createElementBlock("hr", {
                            key: index,
                            class: "border-gray-200"
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 64))
                ]),
                _: 1
              })), [
                [_directive_feature_flagged, _unref(clinicalBlocksFeatureFlag)]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.patient.deceased_at)
      ? (_openBlock(), _createBlock(BaseBanner, {
          key: 1,
          color: "gray",
          label: 
        _ctx.$t('custom.uhb.patient.banner-deceased-at', {
          deceasedDate: formatDate(__props.patient.deceased_at, 'long')
        })
      
        }, null, 8, ["label"]))
      : _createCommentVNode("", true)
  ]))
}
}

})